<p-toolbar [styleClass]="activeView() !== 'default' ? 'yllw-toolbar--quote' : ''">
    <!-- START SECTION -->
    <ng-template #start>
        @if (activeView() === 'quote' || activeView() === 'subscription') {
        <app-quote-toolbar-view />
        }
    </ng-template>

    <!-- CENTER SECTION -->
    <ng-template #center>
        @if ((activeView() === 'quote' || activeView() === 'subscription') && !loadingQuote()) {
        @if (hasValidationIssues()) {
        <app-quote-error-actions />
        }
        @if (isSaving()) {
        <span class="yllw-toolbar__saving">
            <i class="pi pi-spin pi-spinner"></i>
        </span>
        }
        }
    </ng-template>

    <!-- END SECTION -->
    <ng-template #end>
        @if ((activeView() === 'quote' || activeView() === 'subscription') && !loadingQuote()) {
        <div class="yllw-toolbar__actions">
            @if (showSummary()) {
            <div class="yllw-toolbar__summary">
                @for (item of visibleSummaryItems(); track item.label; let last = $last) {
                <span class="yllw-toolbar__summary-item">
                    @if (item.type === 'currency-suffix') {
                    <span class="yllw-toolbar__value">{{ item.value | coreCurrency:null:true }}{{ item.suffix }}</span>
                    } @else {
                    <span class="yllw-toolbar__label">{{ item.label }}:</span>
                    <span class="yllw-toolbar__value">
                        @if (item.type === 'currency') {
                        {{ item.value | coreCurrency:null:true }} {{ currencyShort() }}
                        } @else {
                        {{ item.value | corePercentage: 2 }}
                        }
                    </span>
                    }
                </span>
                @if (!last || hasOverflow()) {
                <span class="yllw-toolbar__divider"></span>
                }
                }
                @if (hasOverflow()) {
                <button class="yllw-toolbar__overflow-btn" #overflowBtn (click)="summaryPopover.toggle($event)">
                    <app-kbd-shortcut [keys]="SHORTCUTS.SUMMARY_OVERFLOW" size="sm"
                        (pressed)="toggleSummaryPopover(overflowBtn, summaryPopover)" />
                    <i class="pi pi-ellipsis-h"></i>
                </button>
                <p-popover #summaryPopover appendTo="body">
                    <div class="yllw-toolbar__overflow-panel">
                        @for (item of summaryItems(); track item.label) {
                        <div class="yllw-toolbar__overflow-row">
                            <span class="yllw-toolbar__label">{{ item.label }}:</span>
                            <span class="yllw-toolbar__value">
                                @if (item.type === 'percentage') {
                                {{ item.value | corePercentage: 2 }}
                                } @else {
                                {{ item.value | coreCurrency:null:true }} {{ currencyShort() }}
                                }
                            </span>
                        </div>
                        }
                    </div>
                </p-popover>
                }
            </div>
            }
            <app-quote-actions mode="primary" />
            <app-quote-actions mode="menu" />
        </div>
        } @else if (activeView() === 'default') {
        <div class="yllw-toolbar__company-section">
            <span class="yllw-toolbar__company-name">
                {{ user()?.selectedCompany?.name?.toUpperCase() }}
                <img [src]="'https://flagcdn.com/48x36/' + user()?.selectedCompany?.countryCode?.toLowerCase() + '.png'"
                    alt="" class="flag-icon" />
            </span>
            <span class="yllw-toolbar__separator">|</span>
            <span class="yllw-toolbar__version">CORE v{{ applicationVersion() }}</span>
        </div>
        }
    </ng-template>
</p-toolbar>
<app-notification-dialog />